import { z } from 'zod';
/** `/healthz` — liveness. Không đụng DB (docs/operations.md §4). */
export const HealthResponse = z.object({
    status: z.literal('ok'),
    version: z.string(),
    uptimeSec: z.number().nonnegative(),
});
/**
 * `/readyz` — readiness. Chỉ ping MySQL.
 *
 * ⚠️ KHÔNG kiểm tra S3 ở đây. Cấu hình S3 nằm trong DB do admin nhập; nếu
 * readiness phụ thuộc S3 thì pod không bao giờ ready ⇒ admin không vào được
 * UI để cấu hình S3 ⇒ deadlock. Xem docs/adr/003-s3-runtime-config.md.
 */
export const ReadyResponse = z.object({
    status: z.enum(['ready', 'not_ready']),
    checks: z.object({
        database: z.enum(['up', 'down']),
    }),
});
//# sourceMappingURL=health.js.map